import { put, takeEvery, all } from 'redux-saga/effects/';
import type { GetReferencesHotelsImagesResponse as Response } from '@lt/api/dist/methods/references/types';

import { api } from 'src/api';

import { setImages } from './slice';
import { fetchHotelImagesAction } from './sagaActions';

type GetHotelImagesProps = ReturnType<typeof fetchHotelImagesAction>;

export function* getHotelImages(action: GetHotelImagesProps) {
  const id = action.payload;
  try {
    const response: Response = yield api.getReferencesHotelsImages({
      hotel_ids: id,
    });

    if (!response?.success) {
      throw new Error(`Can't get hotel images with hotel ID ${id}`);
    }

    yield put(setImages(response));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* hotelImagesSaga() {
  yield all([takeEvery(fetchHotelImagesAction.type, getHotelImages)]);
}
